exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#rotateImg[data-v-5888661d]{-webkit-transform:rotateX(180deg);transform:rotateX(180deg)}.tab-item-title[data-v-5888661d]{border-radius:0 0 5px 5px}.tab-item-img[data-v-5888661d]{border-radius:5px 5px 0 0}[data-v-5888661d] .el-form-item__content{margin-right:30px!important;margin-left:80px!important}[data-v-5888661d] .el-loading-mask{background-color:rgba(0,0,0,.5)!important}", ""]);

// exports
